<template>
  <div class="main">

      <div class="tutorial-content-wrapper">
        <h3>Why do you need an SMS? <TextToSpeechSimple :inputText="textOneSpeech"></TextToSpeechSimple></h3>
        <!-- <p>{{interactionNeeded ? 'This is an interactive page' : 'This is a static page'}}</p> -->
        <!-- <button class="button is-primary" @click="sendData">{{hasInteracted ? 'Good job' : 'Click to interact'}}</button> -->

        <h4>Click on some of the reasons below that make sense to you.</h4>

        <div class="checkbox-wrapper">
          <div class="field" v-for="item in helperItems" :key="item.id">
            <input class="is-checkradio" type="checkbox" :id="item.id" :value="item" v-model="item.checked">
            <label :for="item.id">{{item.title}}</label>
            <!-- <span class="face" :class="item.face" v-if="item.checked"> &nbsp;</span> -->
          </div>
        </div>

        <!-- {{checkedItems}} -->
        <!-- <div v-if="checkedItems.length > 0">
          <div v-for="item in checkedItems" :key="item.id">
            <div class="">
              <div class="item-title">{{item.title}}</div>
            </div>  
          </div>
        </div>

        <h1>{{valueCount}}</h1> -->

        <img class="smiley" v-if="valueCount > 2" src="../assets/popeye.jpg" alt="Offshore SMS">
        <h4 v-if="valueCount > 2">Nice work. Click on Next below.</h4>

        <div class="bottom-spacer"></div>


      </div>


  </div>
</template>


<script>

import { db } from '../main.js';

import TextToSpeechSimple from '../components/TextToSpeechSimple.vue';

export default {

  components: {
      TextToSpeechSimple,
  },

  props: [
      'interactionNeeded',
  ],

  mounted() {
    this.loadHelperItems();
  },

  computed: {
    checkedItems() {
      return this.helperItems.filter(item => item.checked);
    },
    valueCount() {
      return this.checkedItems.reduce((acc, item) => acc + item.value, 0);
    }
  },

  data() {
    return {
      hasInteracted: false,
      helperItems: [],
      selectedItems: [],
      textOneSpeech: 'Why do you need an SMS? Click on some of the reasons below, that make sense to you.',
    }
  },

  watch: {
    valueCount() {
      if (this.valueCount > 2) {
        this.sendData();
      }
    }
  },

  methods: {

    loadHelperItems: function() {
      var self = this;
      db.collection("smsReasons").onSnapshot(function(querySnapshot) {
        self.helperItems = [];
        querySnapshot.forEach(function(doc) {
          self.helperItems.push({
            id: doc.id,
            title: doc.data().title,
            // details: doc.data().details
            face: doc.data().face,
            checked: false,
            value: doc.data().value
          });
        });
      });
    },

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

    sendData: function() {
      let self = this;
      self.hasInteracted = true;
      let result = {
        hasInteracted: self.hasInteracted,
        // returnValue: self.returnValue
      }
      this.$emit('sendData', result)
    },
    
  }
}
</script>



<style lang="scss" scoped>

  button {
    margin-top: 1rem;
  }
  h4 {
    margin-top: 2rem;
  }
  .checkbox-wrapper {
    margin-top: 2rem;
    padding-bottom: 2rem !important;
  }

  span {
    &.face {
      display: inline-block;
      width: 30px;
      position: relative;
      height: 17px;
      &.sad {
        color: red;
        &:after {
          content: "\1F641";
          position: absolute;
          right: 0;
          top: -3px;
          font-size: 23px;
        }
      }
      &.flat {
        color: black;
        &:after {
          content: "\1F61F";
          position: absolute;
          right: 0;
          top: -3px;
          font-size: 23px;
        }
      }
      &.happy {
        color: green;
        &:after {
          content: "\1F60A";
          position: absolute;
          right: 0;
          top: -3px;
          font-size: 23px;
        }
      }
    }
  }

</style>